export default "__VITE_ASSET__20959f19__"